import { useContext } from 'react';
import { AccessControlContext, type AccessControlContextValue } from './AccessControlContext';

/**
 * Exposes the hydrated ability and its loading state. Throws outside a provider
 * — a missing provider is a wiring bug, not a deny-all situation.
 */
export function useAccessControl(): AccessControlContextValue {
  const value = useContext(AccessControlContext);
  if (value === null) {
    throw new Error('useAccessControl must be used within an <AccessControlProvider>');
  }
  return value;
}
